import React, { useState, useEffect } from 'react'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import ProviderAPI from 'config/api/ProviderAPI'
import { onError } from 'config/lib/errorLib'
import Loader from 'components/general/Loader'
import CountiesCard from 'components/provider/CountiesCard'
import HelperCard from 'components/provider/HelperCard'

// Minimal coverage selection screen shown immediately after registration.
// User must select coverage (counties or eircode areas) then is redirected to Billing.
// No sidebar, no multi-stage navigation, only the coverage card.
function SelectCoverage(props) {
    const api = new ProviderAPI()
    const [company, setCompany] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        getCompany()
    }, [])

    async function getCompany() {
        try {
            const details = await api.getCompany()
            setCompany(details)
        } catch(e) {
            onError(e)
        } finally {
            setLoading(false)
        }
    }

    function updateCompany(updated) {
        setCompany(updated)
    }

    function updateField(path, value) {
        setCompany(prev => {
            const updated = { ...prev }
            const keys = path.split('.')
            let obj = updated
            for (let i = 0; i < keys.length - 1; i++) {
                obj[keys[i]] = { ...obj[keys[i]] }
                obj = obj[keys[i]]
            }
            obj[keys[keys.length - 1]] = value
            return updated
        })
    }

    // Intercept stage progression from CountiesCard. When it attempts to advance
    // we treat that as coverage completion and notify parent.
    function handleUpdateStage(nextStage) {
        if (nextStage === 'technology') {
            // Coverage saved successfully.
            props.onCoverageSelected && props.onCoverageSelected(company.companyId)
        }
    }

    return (
        <Container maxWidth={false} component={Box} marginTop='2rem'>
            {!loading && company ? (
                <Grid container justifyContent='center' spacing={3}>
                    <Grid item xs={12} md={8}>    
                        <CountiesCard 
                            product='Solar'
                            companyId={company.companyId}
                            coverageType={company.coverageType}
                            counties={company.counties}
                            eircodeAreas={company.eircodeAreas}
                            updateCompany={updateCompany}
                            updateField={updateField}
                            updateStage={handleUpdateStage}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <HelperCard stage='coverage' title='Tip' />
                    </Grid>
                </Grid>
            ) : (
                <Grid container justifyContent='center'>
                    <Grid item xs={12} md={4}>
                        <Box display='flex' justifyContent='center' alignItems='center' style={{height: '30vh'}}>
                            <Loader />
                        </Box>
                    </Grid>
                </Grid>
            )}
        </Container>
    )
}

export default SelectCoverage
